import React, { useState } from 'react';
import { Avatar, Typography, Box, Stack, Container } from '@mui/material';

// Dummy Data
const testimonials = [
  {
    name: 'Afrah',
    title: 'IGCSE Student',
    review:
      'The results came out about 2 days ago, and I got an A for Mathematics for the first time since Y10 and Y11, literally!!! I was so happy and would like to thank Tutopiya for supporting and helping me',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-1.png`,
  },
  {
    name: 'Kashmithra',
    title: 'IGCSE Student',
    review:
      'As a parent, I am looking for ways to support my son’s education. Tutopiya has been a game changer for us. We have used it for a year to support his IGCSE examination. With Tutopiya, my child receives personalized attention and tailored lesson plans that address their specific learning needs',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-2.png`,
  },
  {
    name: 'Alexandra',
    title: 'IGCSE Student',
    review:
      'Biggest thank you to Tutopiya for guiding me into achieving an A* in IGCSE chemistry',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-3.png`,
  },
  {
    name: 'Aryana',
    title: 'IGCSE Student',
    review:
      'I have used Tutopiya over the course of my IGCSE, which I just completed in May. The two subjects that I used Tutopiya for were maths and science, in both, I was able to achieve a high grade',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-4.png`,
  },
  {
    name: 'Bala T',
    title: 'IGCSE Student',
    review:
      'With their able guidance, our child achieved an A grade in physics in the IGCSE exam. The personalized approach and expert recommendation were instrumental in his success. I wholeheartedly recommend Tutopiya to any student seeking academic excellence !!',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-5.png`,
  },
  {
    name: 'Siddarth',
    title: 'IGCSE Student',
    review:
      'My son achieved an A in Physics and a B in Chemistry. He made significant progress in just four months, and we wish we had enrolled him in these classes much sooner',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-6.png`,
  },
  {
    name: 'Sharenya Bala',
    title: 'IGCSE Student',
    review:
      'Hi, my name is Sharenya, and during my IGCSEs, I was assisted by Tutopiya for my math, bio, and chem. My grades improved a lot with their help, so that I jumped from grade 6,5 to grade 8,8 for science. Thank u so much, Tutopiya',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-7.png`,
  },
  {
    name: 'Shaaranya',
    title: 'IGCSE Student',
    review:
      'Tutopiya really helped me a lot over the past year. I had been struggling with economics and computer science, but the tutors were amazing and they really helped me improve',
    image: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/review-8.png`,
  },
];

const ReviewsSection: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedTestimonial = testimonials[selectedIndex];

  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', py: 5 }}>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        flexWrap="wrap"
        mb={4}
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        {testimonials.map((t, index) => (
          <Avatar
            key={index}
            src={t.image}
            sx={{
              width: '64px',
              height: '64px',
              border: index === selectedIndex ? '3px solid #000' : 'none',
              cursor: 'pointer',
            }}
            onClick={() => setSelectedIndex(index)}
          />
        ))}
      </Stack>

      <Box>
        <Typography
          variant="h6"
          fontSize="20px"
          sx={{ textTransform: 'uppercase' }}
          gutterBottom
        >
          {selectedTestimonial.name}
        </Typography>
        {/* <Typography variant="subtitle1" color="#94A3B8" gutterBottom>
          {selectedTestimonial.title}
        </Typography> */}
        <Typography variant="h5" color="text.primary" mt={3}>
          “{selectedTestimonial.review}”
        </Typography>
      </Box>
    </Container>
  );
};

export default ReviewsSection;
